export default {
    appName: "log_front_sdl",
    flogOnlineURL: "https://web-upload.intsig.net/log/front",
    flogDevURL: "https://web-upload-test.intsig.net/log/front",
    wxCorpid: "wx8659eeddd5ec406e",
    errorNotice: {
        front: "AIM-企业信息化 毛柳柳",
        backend: "AIM-企业信息化 黄辉骏",
        it: "AIM-企业信息化 王钢"
    }
}
